App.controller('RegulationsCtrl', ['$scope', '$stateParams', '$sce', '$state', '$http', function ($scope, $stateParams, $sce, $state, $http) {
    
    $scope.step = 'Regulamin';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);
}]);